import "vuetify/styles";
import "@socotec.io/socio-vue-components/style.css";
import "@/scss/svc-overrides.scss";
import { createVuetify } from "vuetify";
import { useI18n } from "vue-i18n";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";
import { socioVuetifyConfig } from "@socotec.io/socio-vue-components";
import merge from "lodash/merge";

const buildDefaults = (i18n) => {
  const field = {
    density: "comfortable",
    placeholder: i18n.global.t("inputPlaceholder"),
  };
  return {
    VTextField: field,
    VSelect: field,
    VTextarea: field,
    VCombobox: field,
    VAutocomplete: field,
    VCheckbox: { density: "comfortable" },
    VCard: { variant: "flat" },
  };
};

const ATMO_COLORS = {
  info: "#00ACE8",
  "on-info": "#141F35",
  "info-container": "#E6F7FD",
  warning: "#FCB902",
  "on-warning": "#141F35",
  "warning-container": "#FFF8E6",
};

const createAtmoVuetify = (i18n) =>
  createVuetify(
    merge({}, socioVuetifyConfig, {
      defaults: buildDefaults(i18n),
      theme: { themes: { light: { colors: ATMO_COLORS } } },
      locale: {
        adapter: createVueI18nAdapter({ i18n, useI18n }),
      },
    })
  );

export default createAtmoVuetify;
